"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChatDirectMessage = void 0;
const react_1 = __importDefault(require("react"));
const stream_chat_react_1 = require("stream-chat-react");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const use_plugin_1 = require("@app/util/hooks/use-plugin");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useChatDirectMessage = (recipientId) => {
    const workspaceId = (0, store_1.useRootSelector)((state) => state.workspaceId);
    const me = (0, store_1.useRootSelector)((state) => state.me);
    const recipientIsMe = me.id === recipientId;
    const { client } = (0, stream_chat_react_1.useChatContext)();
    const { isPluginEnabled } = (0, use_plugin_1.usePlugin)();
    const isChatEnabled = isPluginEnabled('chat');
    const isConnected = Boolean(client.user);
    const [isValidRecipient, setIsValidRecipient] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        if (!isChatEnabled || !isConnected || recipientIsMe) {
            return;
        }
        client
            .queryUsers({
            id: {
                $eq: recipientId,
            },
        })
            .then((result) => {
            setIsValidRecipient((0, util_1.isValue)(workspaceId) && Boolean(result?.users?.some((user) => user.teams?.includes(workspaceId))));
        })
            .catch((error) => {
            console.log('useChatDirectMessage => queryUsers failed', error);
        });
    }, [recipientId, isChatEnabled, isConnected]);
    return {
        canUseDirectMessage: !recipientIsMe && isValidRecipient && isChatEnabled && isConnected,
        canActivateChat: !recipientIsMe && !isChatEnabled && util_1.permissionsUtil.canWrite('settingsaccessroles'),
        startDirectMessage: async () => {
            const existingChannels = await client.queryChannels({
                members: {
                    $in: [recipientId],
                },
                type: 'messaging',
                joined: true,
                team: workspaceId,
            });
            if (existingChannels[0]) {
                util_1.routeUtil.navigate(`/communication/chat/${existingChannels[0].cid}`);
                return;
            }
            const channelId = window.crypto.randomUUID();
            const channel = client.channel('messaging', channelId, {
                members: [client.user?.id ?? '', recipientId],
                team: workspaceId,
            });
            await channel.create();
            if ((0, util_1.isUndefined)(channel.id)) {
                util_1.notification.error({ message: (0, util_1.t)('ERR_UNKNOWN') });
                return;
            }
            util_1.routeUtil.navigate(`/communication/chat/${channel.id}`);
        },
    };
};
exports.useChatDirectMessage = useChatDirectMessage;
